import { Helmet } from 'react-helmet-async'
import { useShop } from 'shop/hooks'

interface Props {
  url: string
}

export const Canonical = (props: Props) => {
  const { partner } = useShop()
  const { seo } = partner || {}

  if (!seo?.enabled) {
    return <></>
  }

  return (
    <Helmet>
      <link rel='canonical' href={props.url} />
    </Helmet>
  )
}
